import { UIHeading2, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AvgPriceInformer.css';
import { formatAvgPrice } from './formatAvgPrice';
import { IAvgPriceInformer } from '../../../types/offersData';

export interface IAvgPriceInformerProps {
  avgPriceInformer: IAvgPriceInformer;
  isRent: boolean;
}

export const AvgPriceInformerComponent: React.FC<IAvgPriceInformerProps> = ({ avgPriceInformer, isRent }) => {
  const { value, unit } = formatAvgPrice(avgPriceInformer, { isRent });

  return (
    <div className={styles['root']} data-name="AvgPriceInformer">
      <UIHeading4>Средняя цена в результатах поиска</UIHeading4>
      <div className={styles['value']}>
        <UIHeading2>{value}</UIHeading2>
        <UIHeading4>{unit}</UIHeading4>
      </div>
    </div>
  );
};

AvgPriceInformerComponent.displayName = 'AvgPriceInformer';

export const AvgPriceInformer = React.memo(AvgPriceInformerComponent);
